import React, { FC } from "react";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { OrganizationSettingsFormValues } from "../../../../OrganizationSettings.types";

import { Autocomplete, TextField } from "@components/base";
import { useGetNaceDivisions } from "@api";
import { useUserStore } from "@store/user";

interface NaceCodeIndustry {
  control: Control<OrganizationSettingsFormValues>;
  naceSectionId: string;
}

const NaceCodeIndustry: FC<NaceCodeIndustry> = ({ control, naceSectionId }) => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { naceDivisions, naceDivisionsEnabled, isPendingGetNaceDivisions } =
    useGetNaceDivisions(user, {
      naceSectionId,
    });

  return (
    naceDivisionsEnabled && (
      <Controller
        control={control}
        name="naceCodeIndustry"
        rules={{ required: t("organizationSettings.chooseIndustryRequired") }}
        render={({
          field,
          fieldState: { error },
        }): React.ReactElement => (
          <Autocomplete
            options={naceDivisions ?? []}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(a, b) => a.id === b.id}
            loading={isPendingGetNaceDivisions}
            value={
              naceDivisions?.find((d) => d.id === field.value) ?? null
            }
            onChange={(_, option) => field.onChange(option?.id ?? "")}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("organizationSettings.chooseIndustry")}
                helperText={error?.message}
                error={Boolean(error)}
              />
            )}
          />
        )}
      />
    )
  );
};

export default NaceCodeIndustry;
